/* URUZEN — global.js */
(function () {
  // Selector de ofertas (variantes) en la página de producto
  document.querySelectorAll('.ofertas').forEach(function (contenedor) {
    var ofertas = contenedor.querySelectorAll('.oferta');
    ofertas.forEach(function (oferta) {
      oferta.addEventListener('click', function () {
        var input = oferta.querySelector('input[type="radio"]');
        if (!input || input.disabled) return;
        input.checked = true;
        actualizarCantidad();
        ofertas.forEach(function (o) { o.classList.remove('oferta--activa'); });
        oferta.classList.add('oferta--activa');
      });
    });
  });

  // Cantidad = solo la oferta elegida (upsell se agrega aparte)
  function actualizarCantidad() {
    var qty = document.getElementById('CantidadOferta');
    if (!qty) return;
    var sel = document.querySelector('.ofertas input[type="radio"]:checked');
    qty.value = sel ? parseInt(sel.getAttribute('data-cantidad') || '1', 10) : 1;
  }
  actualizarCantidad();

  // Barra de compra fija al scrollear
  var barra = document.getElementById('CompraFija');
  var botonPrincipal = document.getElementById('BotonComprar');
  if (barra && botonPrincipal && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      var pasado = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      barra.classList.toggle('compra-fija--visible', pasado);
      barra.setAttribute('aria-hidden', pasado ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(botonPrincipal);
  }

  // Galería: slider con snap sincronizado con miniaturas
  var slider = document.getElementById('GaleriaSlider');
  if (slider) {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.galeria-thumb'));
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        slider.scrollTo({ left: slider.clientWidth * i, behavior: 'smooth' });
      });
    });
    var timerGal;
    slider.addEventListener('scroll', function () {
      clearTimeout(timerGal);
      timerGal = setTimeout(function () {
        var idx = Math.round(slider.scrollLeft / slider.clientWidth);
        thumbs.forEach(function (t, i) { t.classList.toggle('activa', i === idx); });
      }, 80);
    });
  }

  // Carrito: steppers de cantidad
  document.querySelectorAll('.car-qty').forEach(function (box) {
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = box.querySelector('input');
        var v = parseInt(input.value || '0', 10) + parseInt(b.getAttribute('data-paso'), 10);
        input.value = Math.max(0, v);
        var form = document.getElementById('FormCarrito');
        if (form) form.submit();
      });
    });
  });

  // Carrito: protección de envío
  var prot = document.getElementById('ProteccionCheck');
  if (prot) {
    prot.addEventListener('change', function () {
      var id = prot.getAttribute('data-variant');
      var req;
      if (prot.checked) {
        req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) });
      } else {
        var updates = {};
        updates[id] = 0;
        req = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
      }
      req.then(function () { location.reload(); });
    });
  }

  // Cerrar el menú móvil al hacer click en un link
  document.querySelectorAll('.menu-movil__panel a').forEach(function (a) {
    a.addEventListener('click', function () {
      var det = a.closest('details');
      if (det) det.removeAttribute('open');
    });
  });
})();
